"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCopyToClipboard = useCopyToClipboard;
var _react = require("react");
function useCopyToClipboard({
  timeout = 2000,
  content
}) {
  const timer = (0, _react.useRef)(null);
  const [isCopied, setIsCopied] = (0, _react.useState)(false);
  const copyToClipboard = (0, _react.useCallback)(() => {
    navigator.clipboard.writeText(content);
    setIsCopied(true);
    clearTimeout(timer.current || 0);
    timer.current = setTimeout(() => setIsCopied(false), timeout);
  }, [content, timeout]);
  return {
    isCopied,
    copyToClipboard
  };
}